import React from "react";
import { Col, Row } from "react-bootstrap";

const RoofSloopMonoSlope = ({ caseData, buildingType }) => {
  // if (!caseData && buildingType !== "MCS") return null;
    if (!caseData && !["MCS", "MSMSB","MLMB"].includes(buildingType)) return null;


  // Mono slope image for MCS building type
  const monoSlopImage = "/assets/img/halleysblue/mono_span_building_images/mono_slope _building.jpg";
  const monoSlopMultiSpanImage = "/assets/img/halleysblue/monoslope_multispan_building/monoslope_multispan_building.jpg";
  const multiLevelMezznnineBuilding = "/assets/img/halleysblue/multi_level_mezzanine_building/multi_level_mezzanine_building.jpg";

  // Images per case for CS building type
  const caseImages = {
    C1: "/assets/img/halleysblue/clear_span_roof_images/case_01_model.jpg",
    C2: "/assets/img/halleysblue/clear_span_roof_images/case_02_model.jpg",
    C3: "/assets/img/halleysblue/clear_span_roof_images/case_03_model.jpg",
    C4: "/assets/img/halleysblue/clear_span_roof_images/case_04_model.jpg",
  };

  // Input positions for MCS building type (Mono Slope)
  const mcsInputs = [
    {
      id: 1,
      top: "78%",
      left: "44%",
      value: "width",
      width: "7%",
      height: "3%",
      borderColor: "green",
    },
    {
      id: 2,
      top: "41%",
      left: "11%",
      value: "eaveHeightLSW",
      width: "7%",
      height: "4%",
      rotation: -90,
      borderColor: "green",
    },
    {
      id: 3,
      top: "36%",
      left: "77%",
      value: "eaveHeightRSW",
      width: "7%",
      height: "4%",
      rotation: -90,
      borderColor: "green",
    },
    {
      id: 4,
      top: "43%",
      left: "25%",
      value: "clearHeightLSW",
      width: "6%",
      height: "3%",
      rotation: -90,
      borderColor: "green",
    },
    {
      id: 5,
      top: "40%",
      left: "63%",
      value: "clearHeightRSW",
      width: "6%",
      height: "3%",
      rotation: -90,
      borderColor: "green",
    },
    {
      id: 6,
      top: "9.5%",
      left: "44%",
      value: "slope",
      width: "5%",
      height: "3%",
      borderColor: "green",
    },
    /* {
      id: 7,
      top: "25%",
      left: "55%",
      value: "rightSlope",
      width: "5%",
      height: "2.2%",
      borderColor: "green",
    }, */
  /*   {
      id: 8,
      top: "35%",
      left: "85%",
      value: "ridgeHeight",
      width: "7%",
      height: "3%",
      rotation: -90,
      borderColor: "green",
    }, */
    {
      id: 9,
      top: "55%",
      left: "16.6%",
      rotation: -90,
      value: "lswWallHeight",
      width: "6%",
      height: "3%",
      borderColor: "green",
    },
    {
      id: 10,
      top: "55%",
      left: "72.4%",
      rotation: -90,
      value: "rswWallHeight",
      width: "6%",
      height: "3%",
      borderColor: "green",
    },
   /*  {
      id: 11,
      top: "65%",
      left: "30%",
      rotation: 0,
      value: "width1",
      width: "7%",
      height: "3%",
      borderColor: "green",
    },
    {
      id: 12,
      top: "65%",
      left: "60%",
      rotation: 0,
      value: "width2",
      width: "7%",
      height: "3%",
      borderColor: "green",
    }, */
 /*    {
      id: 13,
      top: "15%",
      left: "25%",
      value: "ridgeDistanceLeft",
      width: "7%",
      height: "3%",
      borderColor: "green",
    },
    {
      id: 14,
      top: "15%",
      left: "65%",
      value: "ridgeDistanceRight",
      width: "7%",
      height: "3%",
      borderColor: "green",
    }, */
  ];

   const msmsbInputs  = [
    {
      id: 1,
      top: "82%",
      left: "44%",
      value: "width",
      width: "7%",
      height: "3%",
      borderColor: "green",
    },
    {
      id: 2,
      top: "41%",
      left: "11%",
      value: "eaveHeightLSW",
      width: "7%",
      height: "4%",
      rotation: -90,
      borderColor: "green",
    },
    {
      id: 3,
      top: "36%",
      left: "77%",
      value: "eaveHeightRSW",
      width: "7%",
      height: "4%",
      rotation: -90,
      borderColor: "green",
    },
    {
      id: 4,
      top: "43%",
      left: "25%",
      value: "clearHeightLSW",
      width: "6%",
      height: "3%",
      rotation: -90,
      borderColor: "green",
    },
    {
      id: 5,
      top: "40%",
      left: "63%",
      value: "clearHeightRSW",
      width: "6%",
      height: "3%",
      rotation: -90,
      borderColor: "green",
    },
    {
      id: 6,
      top: "9.5%",
      left: "44%",
      value: "slope",
      width: "5%",
      height: "3%",
      borderColor: "green",
    },
  
    {
      id: 9,
      top: "55%",
      left: "16.6%",
      rotation: -90,
      value: "lswWallHeight",
      width: "6%",
      height: "3%",
      borderColor: "green",
    },
    {
      id: 10,
      top: "55%",
      left: "72.4%",
      rotation: -90,
      value: "rswWallHeight",
      width: "6%",
      height: "3%",
      borderColor: "green",
    },


  ];

   const mlmbInputs = [
    {
      id: 1,
      top: "69%",
      left: "46%",
      value: "width",
      width: "8%",
      height: "4%",
      borderColor: "green",
    },
    {
      id: 2,
      top: "34%",
      left: "6%",
      value: "eaveHeightLSW",
      width: "7%",
      height: "4%",
      rotation: -90,
      borderColor: "green",
    },
    {
      id: 3,
      top: "32%",
      left: "86.6%",
      value: "eaveHeightRSW",
      width: "7%",
      height: "4%",
      rotation: -90,
      borderColor: "green",
    },
  

    {
      id: 9,
      top: "54%",
      left: "9.6%",
      rotation: -90,
      value: "lswWallHeight",
      width: "6%",
      height: "3%",
      borderColor: "green",
    },
    {
      id: 10,
      top: "54%",
      left: "83.6%",
      rotation: -90,
      value: "rswWallHeight",
      width: "6%",
      height: "3%",
      borderColor: "green",
    },

   
  ];

  // Input positions per case for CS building type
  const caseInputs = {
    C1: [
      {
        id: 1,
        top: "19%",
        left: "31%",
        value: "ridgeDistanceLeft",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 2,
        top: "19%",
        left: "60%",
        value: "ridgeDistanceRight",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 3,
        top: "23.8%",
        left: "27%",
        value: "leftSlope",
        width: "5%",
        height: "2.2%",
        borderColor: "green",
      },
      {
        id: 4,
        top: "23.8%",
        left: "68%",
        value: "rightSlope",
        width: "5%",
        height: "2.2%",
        borderColor: "green",
      },
      {
        id: 5,
        top: "44%",
        left: "13%",
        value: "eaveHeightLSW",
        width: "7%",
        height: "4%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 6,
        top: "44%",
        left: "79.2%",
        value: "eaveHeightRSW",
        width: "7%",
        height: "4%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 7,
        top: "49%",
        left: "21.5%",
        value: "clearHeightLSW",
        width: "6%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 8,
        top: "49%",
        left: "71.5%",
        value: "clearHeightRSW",
        width: "6%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 9,
        top: "45%",
        left: "84.4%",
        value: "ridgeHeight",
        width: "7%",
        height: "3%",
        rotation: -90,
        borderColor: "red",
      },
      {
        id: 10,
        top: "73%",
        left: "47%",
        value: "width",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 11,
        top: "59%",
        left: "16.5%",
        rotation: -90,
        value: "lswWallHeight",
        width: "6%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 12,
        top: "58%",
        left: "77.2%",
        rotation: -90,
        value: "rswWallHeight",
        width: "6%",
        height: "3%",
        borderColor: "green",
      },
    ],
    C2: [
      {
        id: 1,
        top: "14%",
        left: "32%",
        value: "ridgeDistanceLeft",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 2,
        top: "14%",
        left: "60%",
        value: "ridgeDistanceRight",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 3,
        top: "18.7%",
        left: "27%",
        value: "leftSlope",
        width: "5%",
        height: "2.2%",
        borderColor: "red",
      },
      {
        id: 4,
        top: "18.7%",
        left: "68%",
        value: "rightSlope",
        width: "5%",
        height: "2.2%",
        borderColor: "red",
      },
      {
        id: 5,
        top: "46%",
        left: "13%",
        value: "eaveHeightLSW",
        width: "7%",
        height: "4%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 6,
        top: "44%",
        left: "79%",
        value: "eaveHeightRSW",
        width: "7%",
        height: "4%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 7,
        top: "49%",
        left: "21.5%",
        value: "clearHeightLSW",
        width: "6%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 8,
        top: "49%",
        left: "71.9%",
        value: "clearHeightRSW",
        width: "6%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 9,
        top: "45%",
        left: "84.4%",
        value: "ridgeHeight",
        width: "7%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 10,
        top: "73%",
        left: "46%",
        value: "width",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 11,
        top: "59%",
        left: "16.5%",
        rotation: -90,
        value: "lswWallHeight",
        width: "6%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 12,
        top: "59%",
        left: "77.2%",
        rotation: -90,
        value: "rswWallHeight",
        width: "6%",
        height: "3%",
        borderColor: "green",
      },
    ],
    C3: [
      {
        id: 1,
        top: "10%",
        left: "30%",
        value: "ridgeDistanceLeft",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 2,
        top: "10%",
        left: "55%",
        value: "ridgeDistanceRight",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 3,
        top: "13.6%",
        left: "26%",
        value: "leftSlope",
        width: "5%",
        height: "2.4%",
        borderColor: "red",
      },
      {
        id: 4,
        top: "13.6%",
        left: "69%",
        value: "rightSlope",
        width: "5%",
        height: "2.4%",
        borderColor: "red",
      },
      {
        id: 5,
        top: "41%",
        left: "14%",
        value: "eaveHeightLSW",
        width: "7%",
        height: "4%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 6,
        top: "41%",
        left: "80.6%",
        value: "eaveHeightRSW",
        width: "7%",
        height: "4%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 7,
        top: "49%",
        left: "22.2%",
        value: "clearHeightLSW",
        width: "6%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 8,
        top: "49%",
        left: "69.8%",
        value: "clearHeightRSW",
        width: "6%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 9,
        top: "45%",
        left: "85.6%",
        value: "ridgeHeight",
        width: "7%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 10,
        top: "74%",
        left: "47%",
        value: "width",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 11,
        top: "56%",
        left: "17.2%",
        rotation: -90,
        value: "lswWallHeight",
        width: "6%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 12,
        top: "56%",
        left: "77.7%",
        rotation: -90,
        value: "rswWallHeight",
        width: "6%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 13,
        top: "69.4%",
        left: "28%",
        rotation: 0,
        value: "width1",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 14,
        top: "69.4%",
        left: "59%",
        rotation: 0,
        value: "width2",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
    ],
    C4: [
      {
        id: 1,
        top: "14%",
        left: "26%",
        value: "ridgeDistanceLeft",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 2,
        top: "14%",
        left: "53%",
        value: "ridgeDistanceRight",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 3,
        top: "19%",
        left: "25%",
        value: "leftSlope",
        width: "5%",
        height: "2.2%",
        borderColor: "red",
      },
      {
        id: 4,
        top: "18.7%",
        left: "66%",
        value: "rightSlope",
        width: "5%",
        height: "2.2%",
        borderColor: "red",
      },
      {
        id: 5,
        top: "40%",
        left: "11.2%",
        value: "eaveHeightLSW",
        width: "7%",
        height: "4%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 6,
        top: "40%",
        left: "77.6%",
        value: "eaveHeightRSW",
        width: "7%",
        height: "4%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 7,
        top: "45%",
        left: "19.8%",
        value: "clearHeightLSW",
        width: "6%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 8,
        top: "46%",
        left: "70.6%",
        value: "clearHeightRSW",
        width: "6%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 9,
        top: "41%",
        left: "83%",
        value: "ridgeHeight",
        width: "7%",
        height: "3%",
        rotation: -90,
        borderColor: "green",
      },
      {
        id: 10,
        top: "71%",
        left: "44%",
        value: "width",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 11,
        top: "54%",
        left: "14.8%",
        rotation: -90,
        value: "lswWallHeight",
        width: "6%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 12,
        top: "54%",
        left: "75.5%",
        rotation: -90,
        value: "rswWallHeight",
        width: "6%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 13,
        top: "66.4%",
        left: "28%",
        rotation: 0,
        value: "width1",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
      {
        id: 14,
        top: "66.4%",
        left: "56%",
        rotation: 0,
        value: "width2",
        width: "7%",
        height: "3%",
        borderColor: "green",
      },
    ],
  };

  // Render Mono Slope for MCS building type
  if (buildingType === "MCS") {
    return (
      <Row className="justify-content-center">
        <Col xs={12} className="d-flex justify-content-center">
          <div style={{ position: "relative", width: "100%", maxWidth: "1400px" }}>
            <img
              src={monoSlopImage}
              alt="Mono Slope Building"
              style={{ width: "100%", height: "auto", display: "block" }}
            />
            
            {/* MCS Input Overlays */}
            {mcsInputs?.map((inp) => (
              <input
                key={inp.id}
                type="text"
                name={inp.value}
                value={caseData?.[inp.value] || ""}
                disabled
                style={{
                  position: "absolute",
                  top: inp.top,
                  left: inp.left,
                  transform: `rotate(${inp.rotation || 0}deg)`,
                  width: inp.width,
                  height: inp.height,
                  padding: "4px",
                  border: `1px solid ${inp.borderColor || "#333"}`,
                  borderRadius: "4px",
                  fontSize: "0.8rem",
                  backgroundColor: "white",
                  textAlign: "center",
                }}
              />
            ))}
          </div>
        </Col>
      </Row>
    );
  }

  //MSMSB
 if (buildingType === "MSMSB") {
    return (
      <Row className="justify-content-center">
        <Col xs={12} className="d-flex justify-content-center">
          <div style={{ position: "relative", width: "100%", maxWidth: "1400px" }}>
            <img
              src={monoSlopMultiSpanImage}
              alt="Multi Span Mono Slope Building"
              style={{ width: "100%", height: "auto", display: "block" }}
              onError={(e) => {
                // Fallback if image doesn't exist
                console.error("Image failed to load:", monoSlopMultiSpanImage);
                e.target.style.display = 'none';
              }}
            />
            {/* MSMSB Input Overlays */}
            {msmsbInputs?.map((inp) => (
              <input
                key={inp.id}
                type="text"
                name={inp.value}
                value={caseData?.[inp.value] || ""}
                disabled
                style={{
                  position: "absolute",
                  top: inp.top,
                  left: inp.left,
                  transform: `rotate(${inp.rotation || 0}deg)`,
                  width: inp.width,
                  height: inp.height,
                  padding: "4px",
                  border: `1px solid ${inp.borderColor || "#333"}`,
                  borderRadius: "4px",
                  fontSize: "0.8rem",
                  backgroundColor: "white",
                  textAlign: "center",
                }}
              />
            ))}
          </div>
        </Col>
      </Row>
    );
  }

  // Multi Level Mezzanine Building (MLMB)
  if (buildingType === "MLMB") {
    return (
      <Row className="justify-content-center">
        <Col xs={12} className="d-flex justify-content-center">
          <div style={{ position: "relative", width: "100%", maxWidth: "1400px" }}>
            <img
              src={multiLevelMezznnineBuilding}
              alt="Multi Level Mezzanine Building"
              style={{ width: "100%", height: "auto", display: "block" }}
              onError={(e) => {
                console.error("Image failed to load:", multiLevelMezznnineBuilding);
                e.target.style.display = 'none';
              }}
            />
            {/* MLMB Input Overlays */}
            {mlmbInputs?.map((inp) => (
              <input
                key={inp.id}
                type="text"
                name={inp.value}
                value={caseData?.[inp.value] || ""}
                disabled
                style={{
                  position: "absolute",
                  top: inp.top,
                  left: inp.left,
                  transform: `rotate(${inp.rotation || 0}deg)`,
                  width: inp.width,
                  height: inp.height,
                  padding: "4px",
                  border: `1px solid ${inp.borderColor || "#333"}`,
                  borderRadius: "4px",
                  fontSize: "0.8rem",
                  backgroundColor: "white",
                  textAlign: "center",
                }}
              />
            ))}
          </div>
        </Col>
      </Row>
    );
  }


  // Render Clear Span cases for CS building type
  return (
    <Row className="justify-content-center">
      <Col xs={12} className="d-flex justify-content-center">
        <div style={{ position: "relative", width: "100%", maxWidth: "1400px" }}>
          {/* Case Image */}
          {caseData?.caseTypeCode ? (
            <>
              <img
                src={caseImages[caseData.caseTypeCode]}
                alt={caseData.caseTypeCode}
                style={{ width: "100%", height: "auto", display: "block" }}
              />

              {/* Overlay Inputs */}
              {caseInputs[caseData.caseTypeCode]?.map((inp) => (
                <input
                  key={inp.id}
                  type="text"
                  name={inp.value}
                  value={caseData[inp.value] || ""}
                  disabled
                  style={{
                    position: "absolute",
                    top: inp.top,
                    left: inp.left,
                    transform: `rotate(${inp.rotation || 0}deg)`,
                    width: inp.width,
                    height: inp.height,
                    padding: "4px",
                    border: `1px solid ${inp.borderColor || "#333"}`,
                    borderRadius: "4px",
                    fontSize: "0.8rem",
                    backgroundColor: "white",
                    textAlign: "center",
                  }}
                />
              ))}
            </>
          ) : (
            <div className="text-center text-muted p-4">
              <strong>No case selected for CS building</strong>
            </div>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default RoofSloopMonoSlope;